module.exports = __webpack_public_path__ + "img/ir.553cc093.svg";